import * as React from "react"

import { cn } from "@/lib/utils/utils"
import { Text } from "@/components/Primitives/Text"
import { AlertTriangle } from "lucide-react"
import { Icon } from "../Icon"

interface InputProps extends React.ComponentProps<"input"> {
  error?: string | null
}

function Input({ className, type, error, ...props }: InputProps) {
  return (
    <div className="w-full relative">
      <input
        type={type}
        data-slot="input"
        aria-invalid={error ? "true" : "false"}
        className={cn(
          "file:text-foreground placeholder:text-neutral-400 selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "border-input",
          "focus-visible:border-ring",
          error && "border-destructive focus-visible:border-destructive",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
          className,
        )}
        {...props}
      />
      {error && (
        <Icon
          icon={AlertTriangle}
          size="sm"
          className="text-destructive absolute right-3 top-1/3 -translate-y-2/3 flex items-center justify-center"
        />
      )}
      {error && (
        <Text variant="small" className="text-destructive mt-1">
          {error}
        </Text>
      )}
    </div>
  )
}

export { Input }
